/**
 * @ngdoc class
 * @name Campaign
 * @description
 * This class represent a Campaign.
 *
 * @memberof common
 */
class Campaign {
  /**
   * Class constructor.
   * @param {Object} campaign          The necesary data to build the Campaign.
   * @param {Object} campaignsSettings The campaign settings object.
   * @ignore
   */
  constructor(campaign, campaignsSettings) {
    /**
     * The local reference to the `id` property.
     * @type {String}
     */
    this.id = campaign.id;
    /**
     * The local reference to the `cover_image` property.
     * @type {String}
     */
    this.coverImage = campaign.cover_image;
    /**
     * The local reference to the `name` property.
     * @type {String}
     */
    this.name = campaign.name;
    /**
     * The local reference to the `short_description` property.
     * @type {String}
     */
    this.shortDescription = campaign.short_description;
    /**
     * The local reference to the `long_description` property.
     * @type {String}
     */
    this.longDescription = campaign.long_description;
    /**
     * The local reference to the `guidelines` property.
     * @type {Array}
     */
    this.guidelines = campaign.guidelines;
    /**
     * The local reference to the `updated_at` property.
     * @type {String}
     */
    this.updatedAt = campaign.updated_at;
    /**
     * The local reference to the `guidelines` property.
     * @type {Array}
     */
    this.guidelines = campaign.guidelines;
    /**
     * The local reference to the `settings` property.
     * @type {Object}
     */
    this.settings = campaign.settings;
    /**
     * The local reference to the `CONNOTATIONS` constant property.
     * @type {Object}
     */
    this.CONNOTATIONS = {
      NEGATIVE: 'negative',
      POSITIVE: 'positive',
    };
    /**
     * The local reference to the `campaignsSettings` property.
     * @type {Object}
     */
    this.campaignsSettings = campaignsSettings;
  }
  /**
   * Get a default campaign for edition.
   * @return {Object} the default campaign ready for edit.
   * @property {Number}  id                         the campaign id.
   * @property {String}  name                       the campaign name.
   * @property {String}  coverImage                 the campaign cover image.
   * @property {String}  shortDescription           the campaign short description.
   * @property {String}  longDescription            the campaign long description.
   * @property {Object}  guidelines                 the campaign guidelines.
   * @property {Array}   guidelines.positive        the campaign positive guidelines array.
   * @property {Array}   guidelines.negative        the campaign nevative guidelines array.
   * @property {Boolean} skipModeration             if the media uploaded should skip moderation.
   * @property {Object}  errors                     if the campaign has any error.
   * @property {Boolean} errors.name                should we display an error in the name.
   * @property {String}  errors.nameExtra           extra error we should display in the name.
   * @property {Boolean} errors.coverImage          should we display an error in the coverImage.
   * @property {String}  errors.coverImageExtra     extra error we should display in coverImage.
   * @property {Object}  errors.guidelines          if the guidelines has any error.
   * @property {Boolean} errors.guidelines.positive should we display an error in the positive.
   * @property {Boolean} errors.guidelines.negative should we display an error in the negative.
   */
  static getDefaultForEdit() {
    return {
      id: 0,
      name: '',
      coverImage: '',
      shortDescription: '',
      longDescription: '',
      guidelines: {
        positive: [{ value: '' }],
        negative: [{ value: '' }],
      },
      skipModeration: false,
      errors: {
        name: false,
        nameExtra: '',
        coverImage: false,
        coverImageExtra: '',
        guidelines: {
          positive: false,
          negative: false,
        },
      },
    };
  }
  /**
   * Process a campaign for edition.
   * @return {Object} the campaign ready for edit.
   * @property {Number}  id                         the campaign id.
   * @property {String}  name                       the campaign name.
   * @property {String}  coverImage                 the campaign cover image.
   * @property {String}  shortDescription           the campaign short description.
   * @property {String}  longDescription            the campaign long description.
   * @property {Object}  guidelines                 the campaign guidelines.
   * @property {Array}   guidelines.positive        the campaign positive guidelines array.
   * @property {Array}   guidelines.negative        the campaign nevative guidelines array.
   * @property {Boolean} skipModeration             if the media uploaded should skip moderation.
   * @property {Object}  errors                     if the campaign has any error.
   * @property {Boolean} errors.name                should we display an error in the name.
   * @property {String}  errors.nameExtra           extra error we should display in the name.
   * @property {Boolean} errors.coverImage          should we display an error in the coverImage.
   * @property {String}  errors.coverImageExtra     extra error we should display in coverImage.
   * @property {Object}  errors.guidelines          if the guidelines has any error.
   * @property {Boolean} errors.guidelines.positive should we display an error in the positive.
   * @property {Boolean} errors.guidelines.negative should we display an error in the negative.
   */
  processForEdit() {
    const guidelines = {
      positive: [],
      negative: [],
    };

    this.guidelines.forEach((item) => {
      switch (item.connotation) {
      case this.CONNOTATIONS.NEGATIVE:
        guidelines.negative.push({ value: item.head });
        break;
      case this.CONNOTATIONS.POSITIVE:
        guidelines.positive.push({ value: item.head });
        break;
      default:
        break;
      }
    });

    return {
      id: this.id,
      name: this.name,
      coverImage: this.coverImage,
      shortDescription: this.shortDescription,
      longDescription: this.longDescription,
      guidelines,
      skipModeration: angular.equals(
        this.settings[this.campaignsSettings.skipModeration.key],
        this.campaignsSettings.skipModeration.val,
      ),
      errors: {
        name: false,
        nameExtra: '',
        coverImage: false,
        coverImageExtra: '',
        guidelines: {
          positive: false,
          negative: false,
        },
      },
    };
  }
}

export default Campaign;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/models/campaign.js